if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      this.padDigits = this.dataset.padDigits === 'true';
      this.expiryBehavior = this.dataset.expiryBehavior || 'default';
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');
      this.gridEl = this.querySelector('.countdown__grid');
      this.endTextEl = this.querySelector('.js-countdown-end');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    formatValue(value) {
      return this.padDigits ? String(value).padStart(2, '0') : value;
    }

    updateValues(days, hours, mins, secs) {
      if (!this.daysEl || !this.hoursEl || !this.minsEl || !this.secsEl) return;

      this.daysEl.textContent = this.formatValue(days);
      this.hoursEl.textContent = this.formatValue(hours);
      this.minsEl.textContent = this.formatValue(mins);
      this.secsEl.textContent = this.formatValue(secs);
    }

    showExpiredState() {
      this.dataset.expired = 'true';
      this.updateValues(0, 0, 0, 0);

      if (this.endTextEl) {
        if (this.gridEl) this.gridEl.hidden = true;
        this.endTextEl.hidden = false;
        this.setAttribute('aria-label', this.endTextEl.textContent.trim());
      }
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        if (this.expiryBehavior === 'message') this.showExpiredState();
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.updateValues(days, hours - days * 24, mins - hours * 60, secs - mins * 60);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
